import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { MainLayout } from '../../layouts'
import { SEO, AboutInfo } from '../../components'

import './about.sass'

const getAbout = graphql`
  query About {
    One: contentfulInformation(title: { eq: "About Us" }) {
      title
      image {
        fluid(maxWidth: 1200) {
          ...GatsbyContentfulFluid
        }
        title
      }
      content {
        json
      }
    }
    Two: contentfulInformation(title: { eq: "About Two" }) {
      title
      image {
        fluid(maxWidth: 1200) {
          ...GatsbyContentfulFluid
        }
        title
      }
      content {
        json
      }
    }
  }
`

const AboutPage = () => {
  const data = useStaticQuery(getAbout)
  return (
    <MainLayout>
      <SEO title="About" />
      <div className="container infoPage">
        <h2 className="title withLine">{data.One.title}</h2>
        <div className="titleLine"></div>
        <AboutInfo
          text={data.One.content.json}
          image={data.One.image.fluid}
          alt={data.One.image.title}
          classprop="aboutInfoTwo"
        />
        <AboutInfo
          text={data.Two.content.json}
          image={data.Two.image.fluid}
          alt={data.Two.image.title}
          classprop="aboutInfo"
        />
      </div>
    </MainLayout>
  )
}

export default AboutPage
